import React from 'react';
import { sha1 } from 'js-sha1';
import { useTranslation } from '@10d/tend-ui-locale/hooks/useTranslation';
import { Logout } from '@10d/tend-ui-icons/Logout';
import { User } from '@10d/tend-ui-icons/User';
import { Profile as Profile$1 } from '@10d/tend-ui/components';
import { useRole } from '../../../../hooks/useRole.js';

const DOMAIN = 'https://avatar.samoletgroup.ru';
const Profile = ({ user, items, onLogout }) => {
    const t = useTranslation();
    const { isEmployee } = useRole(user);
    const _items = React.useMemo(() => {
        const defaultItems = [
            isEmployee && {
                key: 'profile-menu-item-profile',
                label: t(['widgets', 'Layout', 'Profile', 'profile']),
                icon: React.createElement(User, { color: 'gray500' }),
                onClick: () => {
                    window.open('https://team.samoletgroup.ru/', '_blank');
                },
            },
            {
                key: 'profile-menu-item-logout',
                label: t(['widgets', 'Layout', 'Profile', 'logout']),
                icon: React.createElement(Logout, { color: 'gray500' }),
                onClick: onLogout,
            },
        ].filter(Boolean);
        return typeof items === 'function'
            ? items(defaultItems)
            : (items || []).concat(defaultItems);
    }, [isEmployee, items, onLogout, t]);
    return (React.createElement(Profile$1, { items: _items, avatar: React.useMemo(() => {
            if (!user)
                return;
            const source = new URL(`media/${sha1(user.username)}.jpg`, DOMAIN);
            return { src: source.href, bordered: true };
        }, [user]), title: [user === null || user === void 0 ? void 0 : user.firstName, user === null || user === void 0 ? void 0 : user.lastName].filter(Boolean).join(' '), description: user === null || user === void 0 ? void 0 : user.email }));
};

export { Profile };
